import * as Sentry from '@sentry/react';

if (__DEPLOY_ENV__ !== 'local' && __DEPLOY_ENV__ !== 'docker') {
  Sentry.init({
    environment: __DEPLOY_ENV__,
    release: `slo-ui@${process.env.npm_package_version}`,
    dsn: 'https://af482c8e46de4b7388a0cfba48e14691@o55978.ingest.sentry.io/5988855',
    ignoreErrors: [
      // @see https://stackoverflow.com/a/50387233 Also Sentry "ignoreErrors"
      // filters out errors when partial matches are found
      'ResizeObserver loop',
      'await is only valid in async functions',
      // third-party script error (JSM CS Boysenberry team)
      'getBumpableSLOs',
      // @see https://stackoverflow.com/a/74216043
      'webkit-masked-url',
      // from mobile browsers
      'get-frame-manager-configuration',
      // https://hello.jira.atlassian.cloud/browse/TOME-3479
      'The request failed and the interceptors did not return an alternative response',
    ],
  });
}

export default Sentry;
